import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    title = environment.title;
    public ApiUrl: string = environment.apiUrl;
    constructor(private router: Router, private titleService: Title) {}

    ngOnInit() {
        this.titleService.setTitle(this.title);
    }
}
